import React from 'react';

const ProfileSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50/50 pb-20 animate-pulse">
      {/* Cover Area Placeholder */}
      <div className="h-64 bg-gray-200 w-full"></div>
      
      <div className="container mx-auto px-4 sm:px-6 -mt-20 relative z-10">
        <div className="bg-white rounded-3xl p-6 sm:p-10 shadow-xl shadow-gray-200/50 border border-gray-100 max-w-5xl mx-auto">
          
          <div className="flex flex-col md:flex-row gap-8 items-start">
            {/* Avatar */}
            <div className="w-32 h-32 rounded-full bg-gray-200 border-4 border-white shadow-lg shrink-0"></div>
            
            <div className="flex-1 w-full space-y-4 pt-2">
              <div className="flex justify-between items-start">
                <div>
                  <div className="h-8 w-48 bg-gray-200 rounded-lg mb-2"></div>
                  <div className="h-4 w-32 bg-gray-100 rounded mb-4"></div>
                </div>
                <div className="h-10 w-28 bg-gray-200 rounded-full"></div>
              </div>
              
              <div className="space-y-2 max-w-2xl">
                <div className="h-4 bg-gray-100 rounded w-full"></div>
                <div className="h-4 bg-gray-100 rounded w-5/6"></div>
                <div className="h-4 bg-gray-100 rounded w-4/6"></div>
              </div>
              
              <div className="pt-4 border-t border-gray-50 flex gap-8">
                <div className="h-12 w-20 bg-gray-100 rounded-xl"></div>
                <div className="h-12 w-20 bg-gray-100 rounded-xl"></div>
                <div className="h-12 w-20 bg-gray-100 rounded-xl"></div>
                <div className="h-12 w-20 bg-gray-100 rounded-xl"></div>
              </div>
            </div>
          </div>
          
        </div>

        <div className="max-w-5xl mx-auto mt-12">
          <div className="h-8 w-48 bg-gray-200 rounded-lg mb-6"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm aspect-[4/3] flex flex-col">
                <div className="flex-1 bg-gray-200"></div>
                <div className="h-12 bg-gray-100 w-full"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;
